import { render } from "./SingleMeeting.vue?vue&type=template&id=2a770af2"
import script from "./SingleMeeting.vue?vue&type=script&lang=js"
export * from "./SingleMeeting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__